import * as fs from './fs.js';

const DesignCollectionDetailF = {
  fs,
};
export default DesignCollectionDetailF;
